import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import EuroPreTournament from "../Components/EuroComponents/EuroPreTournament";
import EuroTournament from "../Components/EuroComponents/EuroTournament";
import {useDispatch, useSelector} from "react-redux";
import {get} from "../Axios/get";
import {
    GET_LEAGUE_GROUPS,
    GET_LEAGUE_MATCH_DAYS,
    GET_LEAGUE_TEAMS,
    GET_LEAGUES, SETTINGS,
    STAGING_BASE_URL,
    USER
} from "../Axios/EndPoints";
import {useNavigate, useSearchParams} from "react-router-dom";
import SmallLoader from "../Components/SmallLoader";
import LoginModal from "../Components/LoginModal";
import BottomFooter from "../Components/BottomFooter";

import ImageBottomFooter from "../assets/images/eoro-2024/bottom-footer-euro-2024.svg";
import {setAppSettings} from "../redux/Actions/AppSettings";
import {Modal} from "react-bootstrap";
import EuroCompetitionInstructions from "../Components/EuroComponents/EuroCompetition/EuroCompetitionInstructions";

const Euro = (props) => {
    const {isMobile} = props;
    const dispatch = useDispatch();
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const user = useSelector(state => state?.Login);
    const euroAppSettings = useSelector(state => state?.AppSettings?.appSettings?.EURO);
    // console.log("euroAppSettings >>>", euroAppSettings)

    const [instructionModal, setInstructionModal]= useState(false);

    const [isGamStopModal, setIsGamStopModal] = useState(false);

    const [fullPageLoading, setFullPageLoading] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);

    const [paymentDone, setPaymentDone] = useState(false);
    const [leagueId, setLeagueID] = useState(0);
    const [userPoints, setUserPoint] = useState(0);
    const [jackpot, setJackpot] = useState(0);
    const [showJackpot, setShowJackpot] = useState(false);
    const [entries, setEntries] = useState(0);

    const [leagueTeams, setLeagueTeams] = useState([]);
    const [leagueGroups, setLeagueGroups] = useState([]);

    const [userTournamentSelection, setUserTournamentSelection] = useState(false);

    const [leagueMatchDays, setLeagueMatchDays] = useState([]);
    const [preTournamentDeadLine, setPreTournamentDeadline] = useState(false);


    // console.log("preTournamentDeadLine >>>>", preTournamentDeadLine);
    const fetchSettings = () => {
        let token = user?.user?.token;
        get(SETTINGS, true, token, null,"").then(res => {
            if (res?.data?.success) {
                let tempSettings = {};
                Object.values(res?.data?.data)?.map(value => {
                    tempSettings[value?.key] = value?.value;
                });
                // console.log("temp settings >>>", tempSettings)
                dispatch(setAppSettings(tempSettings));
                let userGamStopStatus = tempSettings?.EURO?.USER_GAMSTOP_STATUS;
                setIsGamStopModal(userGamStopStatus)
                // setPreTournamentDeadline()
                // console.log("temp User_GamStop_Status >>>", userGamStopStatus)

            }
        }).catch(error => console.error("Error while getting settings",
            error.response));
    };

    useEffect(() => {
        if(user?.user?.token){
            fetchSettings();
        }
    }, [user?.user?.token]);

    const fetchUserDetails = () => {
        let token = user?.user?.token;
        let isStaging = parseInt(params.get('staging'));
        setFullPageLoading(true);
        get(
            USER,
            true,
            token,
            dispatch,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("reposne for getting user detail is >>>", res?.data?.data)
            let userTournamentSelection = res?.data?.data?.user_tournament_selection;
            let tournamentDeadline = res?.data?.data?.euro_tournament_deadline;

            // setPreTournamentDeadline(tournamentDeadline);

            setUserTournamentSelection(userTournamentSelection);
            let payment = res?.data?.data?.euro_payment;
            // dispatch(setUserRedux(res?.data?.data));
            if (!payment) {
                // console.log("user payment >>>", payment)
                navigate("/payment")
            } else {
                // console.log("user payment >>>", payment)
                setPaymentDone(true);
            }
        }).catch(error => {
            console.error("Error while getting user Data", error);
        }).finally(() => {
            setFullPageLoading(false);
        });
    };

    const fetchLeagues = () => {
        let token = user?.user?.token;
        let isStaging = parseInt(params.get('staging'));
        get(
            GET_LEAGUES,
            true,
            token,
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("reposne for leagues >>>", res?.data?.data[0])
            setLeagueID(res?.data?.data[0]?.goalserve_id);
            setUserPoint(res?.data?.data[0]?.user_points);
            setJackpot(res?.data?.data[0]?.jackpot);
            setShowJackpot(res?.data?.data[0]?.show_jackpot);
            setEntries(res?.data?.data[0]?.entries);
        }).catch(error => {
            console.error("Error while getting Leagues data :", error);
        })
    }
    const fetchLeagueTeams = (leagueID) => {
        let isStaging = parseInt(params.get('staging'));
        let endpoint = GET_LEAGUE_TEAMS;
        endpoint = endpoint.replace('__LEAGUE_ID__', leagueID);

        get(
            endpoint,
            false,
            "",
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("reposne for leagues >>>", res?.data?.data?.teams)
            setLeagueTeams(res?.data?.data?.teams);
        }).catch(error => {
            console.error("Error while getting League Teams :", error);
        })
    }
    const fetchLeagueGroups = (leagueID) => {
        let isStaging = parseInt(params.get('staging'));
        let endpoint = GET_LEAGUE_GROUPS;
        endpoint = endpoint.replace('__LEAGUE_ID__', leagueID);

        get(
            endpoint,
            false,
            "",
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("reposne for league Groups >>>", res?.data?.data)
            // const filteredData = res?.data?.data?.filter(group => group?.group !== "Ranking of third-placed teams");
            // console.log("filteredData >>>", filteredData)
            setLeagueGroups(res?.data?.data);
        }).catch(error => {
            console.error("Error while getting League Groups :", error);
        })
    }

    const fetchLeagueMatchDays = (leagueID) => {
        let isStaging = parseInt(params.get('staging'));
        let endpoint = GET_LEAGUE_MATCH_DAYS;
        endpoint = endpoint.replace('__LEAGUE_ID__', leagueID);

        get(
            endpoint,
            false,
            "",
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("reponse for league Match days >>>", res?.data?.data)
            setLeagueMatchDays(res?.data?.data);
        }).catch(error => {
            console.error("Error while getting League Match Days :", error);
        })
    }

    useEffect(() => {
        if (!user.isLogin) {
            setShowLoginModal(true);
        } else {
            fetchUserDetails();
        }
    }, [user?.isLogin]);
    useEffect(() => {
        if (user.isLogin) {
            setInstructionModal(false);
        }else{
            setInstructionModal(true)
        }
    }, []);

    useEffect(() => {
        fetchLeagues();
    }, [user?.isLogin && paymentDone]);

    useEffect(() => {
        if (leagueId) {
            fetchLeagueTeams(leagueId);
            fetchLeagueGroups(leagueId);
            fetchLeagueMatchDays(leagueId);
        }
    }, [user?.isLogin && paymentDone && leagueId]);


    const gamStopCheckModal = () => {
        return (
            <Modal
                centered={true}
                size="md"
                show={isGamStopModal}
                onHide={closeModalAndNavigate}
            >
                <Modal.Header
                    className={"border-0"}
                    closeButton
                >
                </Modal.Header>
                <Modal.Body>
                    <div className={"d-flex align-items-center justify-content-center flex-column gap-2"}>
                        <img
                            alt={"info pic"}
                            src={require("../assets/images/gamStopCheck.png")}
                        />
                        <div className={'fw-bold font-20 cabin'}>YOU ARE SIGNED UP TO GAMSTOP</div>
                        <div className={'font-16 cabin text-center'}>
                            You are unable to play
                            SportSkins as you
                            are registered to the self-exclusion gambling
                            scheme via GamStop.
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    };
    const preTournamentDeadLineModal = () => {
        return (
            <Modal
                centered={true}
                size="md"
                show={preTournamentDeadLine}
                onHide={()=>{
                    // e.preventDefault();
                    setPreTournamentDeadline(false);
                    navigate("/");
                }}
            >
                <Modal.Header
                    className={"border-0"}
                    closeButton
                >
                </Modal.Header>
                <Modal.Body>
                    <div className={"d-flex align-items-center justify-content-center flex-column gap-2"}>
                        <img
                            alt={"info pic"}
                            src={require("../assets/images/gamStopCheck.png")}
                        />
                        <div className={'fw-bold font-20 cabin'}>Tournament Dead Line Reached</div>
                        {/*<div className={'font-16 cabin text-center'}>*/}
                        {/*    You are unable to play*/}
                        {/*    SportSkins as you*/}
                        {/*    are registered to the self-exclusion gambling*/}
                        {/*    scheme via GamStop.*/}
                        {/*</div>*/}
                    </div>
                </Modal.Body>
            </Modal>
        );
    };

    const closeModalAndNavigate = () => {
        setIsGamStopModal(false);
        navigate("/");
    };

    const render = () => {
        return (
            <section
            >
                <Helmet>
                    <title>Sportskins - Euro-2024</title>
                    <meta name="description" content="Sportskins- Euro-2024"/>
                </Helmet>
                {
                    fullPageLoading ?
                        <>
                            <SmallLoader loading={fullPageLoading} className={isMobile ? 'text-black' : 'text-white'}/>
                        </>
                        :
                        <>
                            <LoginModal showModal={showLoginModal} setShowModal={setShowLoginModal}/>
                            {
                                userTournamentSelection ?
                                    <>
                                        {
                                            user?.isLogin &&
                                            <>
                                                <EuroTournament
                                                    isMobile={isMobile}
                                                    leagueMatchDays={leagueMatchDays}
                                                    leagueId={leagueId}
                                                    leagueTeams={leagueTeams}
                                                    leagueGroups={leagueGroups}
                                                    setUserTournamentSelection={setUserTournamentSelection}
                                                    userPoints={userPoints}
                                                    jackpot={jackpot}
                                                    showJackpot={showJackpot}
                                                    entries={entries}
                                                />
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        <EuroPreTournament
                                            isMobile={isMobile}
                                            isLogin={user?.isLogin}
                                            user={user}
                                            leagueId={leagueId}
                                            leagueTeams={leagueTeams}
                                            leagueGroups={leagueGroups}
                                            edit={false}
                                            setUserTournamentSelection={setUserTournamentSelection}
                                        />
                                    </>
                            }


                        </>
                }
                <div>
                    <img
                        className={"img-fluid"}
                        src={ImageBottomFooter}
                        alt={"image-footer"}
                    />
                </div>
                <div className={"mt-3"}>
                    <BottomFooter/>
                </div>
                {isGamStopModal && gamStopCheckModal()}
                {
                    preTournamentDeadLine && preTournamentDeadLineModal()
                }
                {
                    instructionModal &&
                    <>
                        <EuroCompetitionInstructions
                            isMobile={isMobile}
                            showModal={instructionModal}
                            setShowModal={setInstructionModal}
                        />
                    </>
                }
            </section>
        );
    }

    return render();
}

export default Euro;
